export enum ESettingsFrontType {
  CLIENT = 'client',
  ADMIN = 'admin',
}
